<!-- src/components/Header.vue -->

<template>
  <el-header class="header-container">
    <!-- logo那一栏 -->
    <el-row class="header-row">
      <el-col :span="10">
        <div class="logo-container">
          <img
            src="@/assets/logo.png"
            alt="军校报考模拟系统"
            class="logo-image"
          />

          <span class="logo-text">砺兵军招升学规划网</span>
        </div>
      </el-col>
      <!-- 右侧按钮部分 vip和登入注册-->
      <el-col :span="14" class="right-col">
        <!-- 修改为 span="14" 并添加 class -->
        <div class="right-content">
          <!-- 汉堡菜单按钮 -->
          <el-button
            class="menu-button"
            type="text"
            @click="toggleMenu"
            v-show="isMobile"
          >
            <el-icon v-if="!menuOpen"><Menu /></el-icon>
            <el-icon v-else><Close /></el-icon>
          </el-button>

          <!-- <el-button
            type="warning"
            icon="Star"
            @click="openVipDialog"
            class="vip-button"
            >开通VIP</el-button
          > -->
          <LoginRegisterDialog ref="loginDialog" />

          <div v-if="isLoggedIn" class="user-avatar">
            <el-dropdown @command="handleCommand">
              <span
                class="el-dropdown-link"
                style="cursor: pointer; display: flex; align-items: center"
              >
                <!-- <el-avatar icon="UserFilled" /> -->
                <span style="margin-left: 8px">{{ username }}</span>
                <el-icon><ArrowDown /></el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="usercenter"
                    >个人中心</el-dropdown-item
                  >
                  <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>

          <button v-else @click="openLoginDialog" class="login-button">
            登录
          </button>
        </div>
      </el-col>
    </el-row>
    <!-- 一级标题 - 桌面端 -->
    <div class="nav-title" v-show="!isMobile">
      <div class="nav-items-container">
        <div class="nav-item">
          <router-link to="/">首页</router-link>
        </div>
        <div class="nav-item">
          <router-link to="/schools">军招报考</router-link>
        </div>
        <div class="nav-item">
          <a href="javascript:void(0)" @click="handleMockClick" class="nav-link"
            >模拟填报</a
          >
        </div>

        <div class="nav-item">
          <router-link to="/questions">互动社区</router-link>
        </div>
        <div class="nav-item">
          <router-link to="/class">线上课堂</router-link>
        </div>
        <div class="nav-item">
          <router-link to="/company">公司简介</router-link>
        </div>
      </div>
    </div>
    <!-- 移动端菜单 -->
    <div v-if="menuOpen" class="mobile-menu-overlay" @click="menuOpen = false">
      <div class="mobile-menu" @click.stop>
        <div class="mobile-menu-content">
          <!-- 关闭按钮 -->
          <div class="mobile-menu-header">
            <el-button
              class="close-button"
              type="text"
              @click="menuOpen = false"
            >
              <el-icon><Close /></el-icon>
            </el-button>
          </div>
          <div
            class="mobile-nav-item"
            v-for="(item, index) in navItems"
            :key="index"
          >
            <a
              v-if="requireLoginRoutes.includes(item.path)"
              href="javascript:void(0)"
              @click="() => handleMobileAuthNav(item.path)"
            >
              {{ item.name }}
            </a>
            <router-link v-else :to="item.path" @click="menuOpen = false">
              {{ item.name }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </el-header>
</template>

<script setup>
import { ref, computed, onMounted, nextTick, onUnmounted } from "vue";

import { ArrowDown, Menu, Close } from "@element-plus/icons-vue";

import { useRouter } from "vue-router";

import { useAuthStore } from "@/store/authStore"; // ✅ 修改为 useAuthStore // 引入 Pinia 的 useUserStore

import { RouterLink } from "vue-router";

import { ElMessage } from "element-plus";

import LoginRegisterDialog from "@/components/LoginRegisterDialog.vue";

// 使用 userStore 获取登录状态

const authStore = useAuthStore();

const router = useRouter();

// 用户状态 - 使用 computed 确保响应式更新

const isLoggedIn = computed(() => authStore.isAuthenticated);

const username = computed(() => authStore.username); //  使用 computed

// 移动端检测
const isMobile = ref(window.innerWidth < 768);
console.log("Initial isMobile:", isMobile.value);

// 菜单状态
const menuOpen = ref(false);

// 导航项数据
const navItems = [
  { name: "首页", path: "/" },
  { name: "军招报考", path: "/schools" },
  { name: "模拟填报", path: "/mocks" },
  { name: "互动社区", path: "/questions" },
  { name: "线上课堂", path: "/class" },
  { name: "公司简介", path: "/company" },
];

// 切换菜单
const toggleMenu = () => {
  console.log("toggleMenu called, current menuOpen:", menuOpen.value);
  menuOpen.value = !menuOpen.value;
  console.log("after toggle, menuOpen:", menuOpen.value);
};

// 监听窗口大小变化
const handleResize = () => {
  const newIsMobile = window.innerWidth < 768;
  if (isMobile.value !== newIsMobile) {
    console.log(
      "Window resize, isMobile changed from",
      isMobile.value,
      "to",
      newIsMobile,
    );
    isMobile.value = newIsMobile;
    if (!isMobile.value) {
      menuOpen.value = false;
      console.log("Menu closed due to non-mobile view");
    }
  }
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});

//声明所有变量

// const router = useRouter();

// const searchInput = ref("");

// 从本地存储获取选中地区，若无则使用默认值

// const selectedRegion = ref(localStorage.getItem("selectedRegion") || "河北");

// 地区列表（可动态加载）

// const regions = ref(["河北", "北京", "上海", "广东", "河南"]);

// 初始化用户状态

// const initUserState = () => {

//   isLoggedIn.value = !!localStorage.getItem("token");

//   username.value = localStorage.getItem("username") || "用户";

//   // 获取用户头像

//   try {

//     const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

//     userAvatar.value = userInfo.avatar || getDefaultAvatar();

//   } catch {

//     userAvatar.value = getDefaultAvatar();

//   }

// };

// 添加获取默认头像方法

// const getDefaultAvatar = () => {

//   try {

//     // 尝试使用 require 方式加载

//     return require("@/assets/images/default-avatar.png");

//   } catch {

//     // 如果加载失败，使用 Element Plus 的默认头像

//     return "";

//   }

// };

// 选择地区方法

// const selectRegion = (region) => {

//   selectedRegion.value = region;

//   localStorage.setItem("selectedRegion", region); // 保存到本地存储

// };

// 页面加载时检查是否已选择地区，未选择则跳转到弹窗（可选）

// onMounted(() => {

//   if (!localStorage.getItem("selectedRegion")) {

//     // 若需要强制首次选择，可在此处调用弹窗组件

//   }

// });

//搜索框方法

// const handleSearch = () => {

//   console.log("执行搜索操作，搜索内容：", searchInput.value);

//   // 这里可以添加实际的搜索逻辑，比如调用API等

// };

// const openVipDialog = () => {

//   console.log("打开开通VIP弹窗");

//   // 这里可以添加实际打开弹窗的逻辑

// };

// 2. 添加调试信息

// 下拉菜单处理

const handleCommand = (command) => {
  if (command === "usercenter") {
    router.push("/usercenter");
  } else if (command === "logout") {
    authStore.logout(); // ✅ 调用 logout 方法

    router.push("/");
  }
};

// 打开登录弹窗方法

const loginDialog = ref(null);

const openLoginDialog = async () => {
  await nextTick();

  if (loginDialog.value && typeof loginDialog.value.openDialog === "function") {
    loginDialog.value.openDialog();
  } else {
    console.error("openDialog 方法不存在或组件未正确挂载");
  }
};

// 需要登录的路由列表
const requireLoginRoutes = [
  "/mocks",
  "/volunteer-planning",
  "/ai-interview",
  "/expert-consultation",
];

// 通用登录检查并跳转
const navigateWithAuth = (route) => {
  if (requireLoginRoutes.includes(route)) {
    if (!authStore.isAuthenticated) {
      ElMessage.warning("请先登录，登录后才能使用该功能");
      openLoginDialog();
      return;
    }
  }
  router.push(route);
};

// 处理模拟填报点击（桌面端）
const handleMockClick = () => {
  navigateWithAuth("/mocks");
};

// 处理模拟填报点击（移动端）
const handleMockClickMobile = () => {
  menuOpen.value = false;
  navigateWithAuth("/mocks");
};

// 处理移动端需要登录的导航
const handleMobileAuthNav = (route) => {
  menuOpen.value = false;
  navigateWithAuth(route);
};

// 处理抽屉菜单关闭
const handleDrawerClose = (done) => {
  done();
};
</script>
<!-- 最新的logo那栏样式 -->
<!-- <style scoped>
.header-container {
  color: #fff;
  height: 60px; /* 调整高度 */
  padding: 0 20px; /* 调整内边距 */
}

.header-row {
  height: 100%;

  align-items: center;

  background: #eae EF3; /* 修改为指定的背景颜色 */
}

.logo-container {
  display: flex;

  align-items: center;
}

.logo-image {
  height: 40px; /* 调整 Logo 尺寸 */

  width: auto;

  object-fit: contain;
}

.logo-text {
  font-size: 18px;

  font-weight: bold;

  margin-left: 10px;

  color: black; /* Logo 文字颜色 */
}

.vip-button {
  font-size: 14px;

  height: 36px;

  margin-right: 20px;
}

.user-avatar {
  margin-right: 20px;
}

.login-button {
  font-size: 14px;

  height: 36px;

  background-color: #409eff;

  color: black;

  border: none;

  border-radius: 4px;

  cursor: pointer;
}
</style> -->
<!-- 一级标题 -->
<!-- <style scoped>
/* 导航栏样式优化 */
::v-deep .el-main {
  padding: 0 !important;
}
.nav-title {
  background: #4c8aff; /* 浅蓝色背景 */
  height: 50px;
  width: 100%; /* 确保宽度为 100% */
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.nav-title .el-row {
  width: 100%;
  display: flex;
  justify-content: space-between; /* 均匀分布导航项 */
  margin: 0;
  padding: 0;
}

.nav-title .el-col {
  flex: 1; /* 等宽分配 */
  min-width: 0; /* 防止内容溢出 */
  text-align: center;
  padding: 0;
}

.nav-title a {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  display: block;
  padding: 0 5px;
  line-height: 50px;
  transition: all 0.3s;
  white-space: nowrap; /* 防止文字换行 */
  overflow: hidden;
  text-overflow: ellipsis; /* 文字过长显示省略号 */
  width: 100%;
}

.nav-title .el-col:hover a {
  background: rgba(255, 255, 255, 0.2);

  border-radius: 4px;
}

/* 响应式调整：在小屏幕上缩小字体 */

@media (max-width: 1200px) {
  .nav-title a {
    font-size: 14px;

    padding: 0 3px;
  }
}
</style> -->
<!-- 第一栏logo系统名那一栏 旧版-->
<!-- <style scoped>
/* 右侧按钮部分 */

.header-row .el-col:last-child {
  display: flex;

  justify-content: flex-end; /* 靠右对齐 */
}

.header-row .el-col:last-child .el-button {
  margin-right: 20px; /* 调整按钮之间的间距 */
}

.header-row {
  align-items: center;

  /* justify-content: space - between; */

  padding: 10px;

  background-color: rgba(249, 249, 249, 249);
}

.logo-container {
  height: 60px;

  display: flex;

  align-items: center;

  gap: 10px;
}

.logo-image {
  height: 80px; /* 控制图片高度 */

  width: auto; /* 保持图片宽高比 */

  object-fit: contain; /* 确保图片完整显示 */
}

.logo-text {
  font-size: 18px;

  font-weight: bold;

  color: #333;

  white-space: nowrap; /* 防止文字换行 */

  margin-right: 2px;
}

.w {
  width: 1300px;

  margin: auto;
}

.grid-content {
  min-height: 36px;

  background-color: white;
}

.region-select {
  display: flex;

  align-items: center;

  gap: 4px;

  font-size: 14px;

  margin-left: 1px;

  margin: auto;
}

/* .login-text {

  font-size: 18px;

  margin-left: 5px;

  margin: auto;

} */

region-dropdown:focus-visible {
  outline: none;
}
</style> -->
<style scoped>
/* 顶部Logo行 */
.header-container {
  padding: 0 !important;
  position: relative;
  z-index: 100;
}

.header-row {
  height: 60px;
  align-items: center;
  background: #ffffff;
  padding: 0 20px;
  margin: 0;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 1;
  min-width: 0;
}

.logo-image {
  height: 40px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
}

.logo-text {
  font-size: 18px;
  font-weight: bold;
  color: black;
  flex-shrink: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

/* 右侧内容区域 */
.right-col {
  display: flex;
  justify-content: flex-end; /* 确保内容靠右 */
}

.right-content {
  display: flex;
  align-items: center;
  justify-content: flex-end; /* 内容靠右对齐 */
  width: 100%; /* 占满整个列 */
  gap: 10px;
  flex-wrap: nowrap;
  overflow: visible;
}

.vip-button {
  font-size: 14px;
  min-width: 44px;
  height: 44px;
  margin-right: 0;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
}

.user-avatar {
  margin-right: 0;
}

.user-avatar .el-dropdown-link {
  min-height: 44px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  transition: all 0.3s;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
}

.user-avatar .el-dropdown-link:hover {
  background: rgba(0, 0, 0, 0.05);
}

.login-button {
  font-size: 14px;
  min-width: 44px;
  height: 44px;
  background-color: #409eff;
  color: white; /* 修改文字颜色为白色 */
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 0 15px;
  transition: all 0.3s;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
}

.login-button:hover {
  background-color: #66b1ff;
}

/* 导航栏样式 */
/* 导航栏样式 - 确保可点击 */
.nav-title {
  background: #4c8aff;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
}

.nav-items-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 20px;
}

.nav-item {
  flex: 1;
  min-width: 0;
  text-align: center;
  height: 50px;
  line-height: 50px;
  position: relative; /* 为链接定位提供上下文 */
}

.nav-item a {
  display: block; /* 关键：使链接填充整个导航项 */
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  padding: 0 10px;
  transition: all 0.3s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
}

.nav-item .nav-link {
  display: block;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  padding: 0 10px;
  transition: all 0.3s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
}

.nav-item .nav-link:hover {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.nav-item a:hover {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

/* 添加激活状态的样式 - 仅精确匹配 */
.nav-item a.router-link-exact-active {
  font-weight: bold;
  background: rgba(255, 255, 255, 0.3);
}

/* 汉堡菜单按钮 */
.menu-button {
  margin-right: 15px;
  font-size: 24px;
  color: #333;
  min-width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.3s;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
}

.menu-button:hover {
  background: rgba(0, 0, 0, 0.05);
}

/* 移动端菜单样式 */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99998;
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
}

.mobile-menu {
  background-color: #4c8aff;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 99999;
  width: 80%;
  max-width: 300px;
  height: 100%;
  overflow-y: auto;
  animation: slideIn 0.3s ease-in-out;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.mobile-menu-content {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.mobile-menu-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.close-button {
  font-size: 24px;
  color: white;
  min-width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s;
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.2);
}

.mobile-nav-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 10px 0;
  transition: all 0.3s;
}

.mobile-nav-item:last-child {
  border-bottom: none;
}

.mobile-nav-item a {
  color: white;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  display: block;
  padding: 15px 0;
  min-height: 44px;
  display: flex;
  align-items: center;
  transition: all 0.3s;
  border-radius: 4px;
  padding: 15px 10px;
}

.mobile-nav-item a:hover {
  color: #e6f0ff;
  background: rgba(255, 255, 255, 0.1);
}

/* 移动端菜单动画效果 */
.mobile-menu {
  transition: transform 0.3s ease-in-out;
}

/* 确保触摸目标足够大 */
.mobile-nav-item a {
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0.3);
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .nav-item a {
    font-size: 14px;
    padding: 0 8px;
  }

  .logo-text {
    font-size: 16px;
  }
}

@media (max-width: 992px) {
  .nav-item a {
    font-size: 13px;
    padding: 0 5px;
    white-space: normal; /* 小屏幕允许换行 */
    line-height: 1.3;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logo-text {
    font-size: 14px;
  }

  .logo-image {
    height: 35px;
  }
}

@media (max-width: 768px) {
  .header-row {
    padding: 0 15px;
    height: 56px;
  }

  .logo-container {
    gap: 8px;
  }

  .logo-text {
    font-size: 12px;
    line-height: 1.2;
  }

  .logo-image {
    height: 30px;
  }

  .login-button {
    min-width: 44px;
    height: 44px;
    padding: 0 15px;
  }

  .user-avatar {
    margin-right: 10px;
  }

  .right-content {
    gap: 10px;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .logo-text {
    font-size: 10px;
  }

  .logo-image {
    height: 28px;
  }

  .header-row {
    padding: 0 12px;
  }

  .menu-button {
    margin-right: 10px;
  }
}
</style>
<!-- 下拉菜单 -->

<!-- <style scoped>
.example-showcase .el-dropdown-link {
  cursor: pointer;

  color: var(--el-color-primary);

  display: flex;

  align-items: center;
}

.user-avatar {
  display: flex;

  align-items: center;

  margin-right: 16px;
}

.el-dropdown-link {
  display: flex;

  align-items: center;

  gap: 8px;
}
</style> -->
